export const ORCHESTRA_T = { it: { tab: "Orchestra" }, en: { tab: "Orchestra" }, es: { tab: "Orquesta" }, pt: { tab: "Orquestra" } };
